import { ThemeService } from './modules/shared/services/theme.service';
import { UsersService } from './modules/shared/services/users.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, ViewChild, TemplateRef } from '@angular/core';
import { AuthenticationService } from './modules/shared/services/authentication.service';
import { Router } from '@angular/router';
import { NotificationsService } from './modules/shared/services/notifications.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {

  @ViewChild("changePasswordModal", { static: false })
  private changePasswordModal: TemplateRef<any>;
  public changeCurrentUserPasswordForm = {};

  constructor(
    public authenticationService: AuthenticationService
    , private router: Router
    , private modalService: NgbModal
    , private usersService: UsersService
    , private themeService: ThemeService
    , private notifications: NotificationsService) { }

  ngOnInit() {
    this.themeService.setDefaultTheme();
    if (!this.authenticationService.isLoggedIn()) {
      return;
    }
    // valida token atual     
    this.authenticationService.validateCurrentToken();
  }

  collapsed = true;
  toggleCollapsed(): void {
    this.collapsed = !this.collapsed;
  }

  changePasswordClicked() {
    this.changeCurrentUserPasswordForm = {};
    this.modalService.open(this.changePasswordModal, { size: 'lg', backdrop: 'static', keyboard: false });
  };

  submitChangeCurrentUserPasswordForm(form) {
    if (!form.valid) {
      Object.keys(form.controls).forEach(key => form.controls[key].markAsDirty());
      return;
    }

    this.usersService.changeCurrentUserPassword(this.changeCurrentUserPasswordForm).subscribe(response => {
      if (!response.success) {
        this.notifications.errors(response.payload.messages);
        return;
      }
      this.notifications.success("Senha alterada com sucesso.");
      this.modalService.dismissAll();
    });
  };

  logout() {
    this.authenticationService.logout();
    this.router.navigate(["/login"]);
  }

  toggleTheme() {
    this.themeService.toggleTheme();
  }
}
